"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyActivity = void 0;
const Constants_1 = require("../Constants");
const index_1 = require("../Base/index");
/**
 * Contains a blank activity that has no dedicated UseCase.
 *
 * Technically, this services as a Breakpoint for the Frontend.
 */
class EmptyActivity extends index_1.FlowNode {
    constructor() {
        super(...arguments);
        this.enabled = true;
    }
    get bpmnType() {
        return Constants_1.BpmnType.emptyActivity;
    }
}
exports.EmptyActivity = EmptyActivity;
//# sourceMappingURL=EmptyActivity.js.map